import React, { FC } from 'react'

import loadable from '@loadable/component'

import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { DefaultLoader } from 'components/presentational/AnimatedWatch/AnimatedWatch'

import { ForeignSwitch } from './ForeignSwitch'

const InterSectionObserver = loadable.lib(() => import('intersection-observer'))

export const LoadingInterSectionObserver: FC<{
  data: GQLForeignRootQuery
}> = ({ data }) => {
  if (
    process.env.browser &&
    typeof window.IntersectionObserver === 'undefined'
  ) {
    return (
      <InterSectionObserver fallback={<DefaultLoader />}>
        {() => <ForeignSwitch data={data} />}
      </InterSectionObserver>
    )
  }

  return <ForeignSwitch data={data} />
}
